export default __webpack_public_path__ + "static/media/tommy.bf959d6d.png";